import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import Auth from "./Auth";
import Common from "./Common";
import Settings from "./Settings";
import GeneralAnalytics from "./GeneralAnalytics";
import clientDashboard from "./clientDashboard";
import activities from "./Activities";
import dailyLivingActivity from "./dailyLivingActivity";
import Users from "./Users";
import CorporateAccounts from "./CorpotateAccounts";
import Report from "./Report";
import AdminSettings from "./AdminSettings";
import AdminDashboard from "./AdminDashboard";
import dailyUpdate from "./dailyUpdate";
import SignUp from "./SignUp";
import Survey from "./Survey";
import CarePlan from "./CarePlan";
import CrudReducer from "./CRUDReducer";
import Inventory from "./Inventory";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    settings: Settings,
    auth: Auth,
    commonR: Common,
    activities: activities,
    dailyLivingActivityR: dailyLivingActivity,
    generalAnalytics: GeneralAnalytics,
    clientDashboard: clientDashboard,
    users: Users,
    corporateAccounts: CorporateAccounts,
    report: Report,
    adminSettings: AdminSettings,
    adminDashboard: AdminDashboard,
    dailyUpdate: dailyUpdate,
    signUp: SignUp,
    surveyR: Survey,
    carePlanR: CarePlan,
    crudR: CrudReducer,
    inventory: Inventory,
  });
